// extracted by mini-css-extract-plugin
export default {"lang":"LangBox_lang__DoA+4","lanBox":"LangBox_lanBox__qEtWs","lang_slc":"LangBox_lang_slc__cqeeC","lang_menu":"LangBox_lang_menu__ZK0p2","show":"LangBox_show__A5g2W"};